import {
  docIcon,
  locationIcon,
  privacyIcon,
  supportIcon,
  termsIcon,
  userProfileIcon,
} from "assets/icons";
import React, { useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import "./AccountSetting.scss";
import { MdPrivacyTip } from "react-icons/md";
import { FaBarsStaggered } from "react-icons/fa6";
import { FaTimes } from "react-icons/fa";

const AccountSetting = () => {
  const [menu, setShowMenu] = useState(false);
  return (
    <div className={`account_settings ${menu ? "showMenu" : ""}`}>
      <div className="container">
        <div className="account_settings_content">
          <aside>
          <button
              type="button"
              className="menu_button"
              onClick={() => setShowMenu(false)}
            >
              <FaTimes />
            </button>
            <ul onClick={() => setShowMenu(false)}>
              <li>
                <NavLink to="/account">
                  <img src={userProfileIcon} alt="" />
                  <span>Profile Details</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/sites">
                  <img src={locationIcon} alt="" />
                  <span>My Sites</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/document-repository">
                  <img src={docIcon} alt="" />
                  <span>Document Repository</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact-us">
                  <img src={supportIcon} alt="" />
                  <span>Contact Us</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/privacy-policy">
                  <img src={privacyIcon} alt="" />
                  {/* <MdPrivacyTip /> */}
                  <span>Privacy Policy</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/terms-of-service">
                  <img src={termsIcon} alt="" />
                  <span>Terms of Service</span>
                </NavLink>
              </li>
            </ul>
          </aside>
          <div className="setting_content">
            <button
              type="button"
              className="menu_button"
              onClick={() => setShowMenu(true)}
            >
              <FaBarsStaggered />
              {/* {!mobileMenu ? : <FaTimes />} */}
            </button>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};
export default AccountSetting;
